module.exports = "fragment PaperCostsFragment on PaperCosts {\n  value\n  upgrade\n}\n"